"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddButtonBase = exports.AddButton = void 0;
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../../../i18n/i18n");
var _useTheme = require("../../../../../theme/utils/useTheme");
var _tooltip = require("../../../../tooltip");
var _useTooltip = require("../../../../tooltip/useTooltip");
var _AddButtonRoot = require("./styled/AddButtonRoot");
var _ToolTipCatcher = require("./styled/ToolTipCatcher");
const AddButtonBase = /*#__PURE__*/_react.default.forwardRef((props, parentRef) => {
  const {
    className,
    clientId,
    onClick,
    onFocus,
    onKeyDown,
    toolTipText,
    i18n,
    disabled = false
  } = props;
  const {
    tooltipProps,
    targetProps
  } = (0, _useTooltip.useTooltip)();
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AddButtonRoot.AddButtonRoot, {
    ref: parentRef,
    onFocus: !disabled ? onFocus : undefined,
    onKeyDown: !disabled ? onKeyDown : undefined,
    className: className,
    "aria-disabled": disabled,
    themeMode: themeMode,
    onClick: !disabled ? onClick : undefined,
    "data-client-id": clientId,
    "aria-label": i18n._( /*i18n*/"Add a custom color"),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_ToolTipCatcher.ToolTipCatcher, targetProps), /*#__PURE__*/_react.default.createElement(_lodestarIcons.AddIcon, {
    size: "xxSmall"
  })), disabled && /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, tooltipProps, /*#__PURE__*/_react.default.createElement(_tooltip.TooltipBody, null, toolTipText)));
});
exports.AddButtonBase = AddButtonBase;
AddButtonBase.displayName = "AddButton";
const AddButton = (0, _i18n.withI18n)(AddButtonBase);
exports.AddButton = AddButton;
//# sourceMappingURL=AddButton.js.map